import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=0f4e9d95&scoped=true&"
import script from "./Tag.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Tag.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Tag.vue?vue&type=style&index=0&id=0f4e9d95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e9d95",
  null
  
)

export default component.exports